import { DomainError } from '../errors/domain-error';

export function canAdminTakedownMembership(params: {
  adminDisabledAt?: Date | string | null;
}): boolean {
  return !params.adminDisabledAt;
}

export function assertAdminMembershipTakedown(params: {
  adminDisabledAt?: Date | string | null;
}): void {
  if (!canAdminTakedownMembership(params)) {
    throw new DomainError('Membership is already disabled by platform moderation');
  }
}

export function assertMembershipNotAdminDisabled(adminDisabledAt?: Date | string | null): void {
  if (adminDisabledAt) {
    throw new DomainError(
      'This membership was disabled by Loamify moderation. Contact support if you believe this is a mistake.',
    );
  }
}

export function isMembershipPubliclyAvailable(params: {
  visibility: string;
  adminDisabledAt?: Date | string | null;
  isOwner?: boolean;
}): boolean {
  if (params.adminDisabledAt && !params.isOwner) {
    return false;
  }
  if (params.visibility !== 'live' && !params.isOwner) {
    return false;
  }
  return true;
}

export function summarizeCreatorMembershipConnectConflicts(params: {
  hasPublishedPaidTier: boolean;
  stripeConnectAccountId?: string | null;
  connectReady: boolean;
}): string[] {
  const conflicts: string[] = [];
  if (params.hasPublishedPaidTier && !params.stripeConnectAccountId) {
    conflicts.push('Paid tier published without Connect account');
  }
  if (params.hasPublishedPaidTier && !params.connectReady) {
    conflicts.push('Connect onboarding incomplete or charges disabled');
  }
  return conflicts;
}

export function summarizeCreatorMembershipBillingHealth(
  subscriptions: Array<{
    stripeSubscriptionId: string | null;
    stripeBillingStatus: string | null;
    pastDueAt: Date | string | null;
    cancelAtPeriodEnd: boolean;
  }>,
) {
  const paid = subscriptions.filter((row) => row.stripeSubscriptionId);
  const pastDueCount = paid.filter(
    (row) => row.stripeBillingStatus === 'past_due' || row.pastDueAt != null,
  ).length;
  const cancelAtPeriodEndCount = paid.filter((row) => row.cancelAtPeriodEnd).length;
  const activePaidCount = paid.filter(
    (row) => row.stripeBillingStatus === 'active' || row.stripeBillingStatus === 'trialing',
  ).length;

  const conflicts: string[] = [];
  if (pastDueCount > 0) {
    conflicts.push(`${pastDueCount} paid member(s) past due`);
  }
  if (cancelAtPeriodEndCount > 0) {
    conflicts.push(`${cancelAtPeriodEndCount} member(s) canceling at period end`);
  }

  return {
    activePaidCount,
    pastDueCount,
    cancelAtPeriodEndCount,
    conflicts,
  };
}

export function buildMembershipReportHref(slug: string | null | undefined): string | null {
  return slug ? `/memberships/${slug}` : null;
}
